<div #calendar class="mp-calendar">
  <div class="calendar-controls">
    <i class="fas fa-angle-left" [class.disabled]="!canGoToPreviousPeriod()" (click)="previousPeriod()"></i>
    @if (currentView === 'DAY') {
      <span class="period-selector"
      (click)="showYearList($event)">{{ MonthsLabels[viewedMonth] | translate }} {{ viewedYear }}</span>
    }
    @if (currentView === 'MONTH') {
      <span class="period-selector" (click)="showDayList($event)">{{ viewedYear }}</span>
    }
    @if (currentView === 'YEAR') {
      <span class="period-selector" (click)="showDayList($event)">{{ years[0] }}
      - {{ years[years.length - 1] }}</span>
    }
    <i class="fas fa-angle-right" (click)="nextPeriod()"></i>
  </div>
  @if (currentView === 'DAY') {
    <div class="calendar-day-headers">
      <span class="day-header">{{ 'CALENDAR.MONDAY_FIRST_LETTER' | translate }}</span>
      <span class="day-header">{{ 'CALENDAR.TUESDAY_FIRST_LETTER' | translate }}</span>
      <span class="day-header">{{ 'CALENDAR.WEDNESDAY_FIRST_LETTER' | translate }}</span>
      <span class="day-header">{{ 'CALENDAR.THURSDAY_FIRST_LETTER' | translate }}</span>
      <span class="day-header">{{ 'CALENDAR.FRIDAY_FIRST_LETTER' | translate }}</span>
      <span class="day-header" [class.de-emphasize-no-business-day]="onlyBusinessDays">
        {{ 'CALENDAR.SATURDAY_FIRST_LETTER' | translate }}
      </span>
      <span class="day-header" [class.de-emphasize-no-business-day]="onlyBusinessDays">
        {{ 'CALENDAR.SUNDAY_FIRST_LETTER' | translate }}
      </span>
    </div>
    <div class="calendar-days">
      @for (dayPadding of daysPadding; track dayPadding) {
        <span class="padding-cell"></span>
      }
      @for (dayOfMonth of days; track dayOfMonth) {
        <span class="calendar-cell"
          [class.selected-start]="isStart(dayOfMonth)"
          [class.selected-end]="isEnd(dayOfMonth)"
          [class.selected-middle]="dayIsBetween(dayOfMonth)"
          [class.disabled]="isBeforeMinDate(dayOfMonth) || !isBusinessDay(dayOfMonth)"
          (click)="!isBeforeMinDate(dayOfMonth) && selectDay(dayOfMonth)">
          <span class="day-number">{{ dayOfMonth }}</span>
        </span>
      }
    </div>
  }

  @if (currentView === 'YEAR') {
    <div class="calendar-years">
      @for (year of years; track year) {
        <span class="calendar-cell"
          [class.selected]="viewedYear === year"
          [class.disabled]="isYearBeforeMinDate(year)"
          (click)="!isYearBeforeMinDate(year) && selectYear($event, year)">
          {{ year }}
        </span>
      }
    </div>
  }

  @if (currentView === 'MONTH') {
    <div class="calendar-months">
      @for (month of months; track month) {
        <span class="calendar-cell"
          [class.selected]="viewedYear === startYear && viewedMonth === month"
          [class.disabled]="isMonthBeforeMinDate(viewedYear, month)"
          (click)="!isMonthBeforeMinDate(viewedYear, month) && selectMonth($event, month)">
          {{ MonthsAbrvLabels[month] | translate }}
        </span>
      }
    </div>
  }

  @if (timeIntervalAllowed) {
    <div class="hours-sections">
      <div class="hour-line">
        <span class="hour-toggle">
          <app-mp-toggle [(toggleState)]="startToggle" (toggleStateChange)="resetTimeField('start')"></app-mp-toggle>
        </span>
        <span class="hour-label">{{ 'CALENDAR.START_HOUR' | translate }}</span>
        @if (startToggle) {
          <span class="hour-picker">
            <app-mp-hour-picker [size]="'small'" [(inputValue)]="startTime">
            </app-mp-hour-picker>
          </span>
        }
      </div>
      <div class="hour-line">
        <span class="hour-toggle">
          <app-mp-toggle [(toggleState)]="endToggle" (toggleStateChange)="resetTimeField('end')"></app-mp-toggle>
        </span>
        <span class="hour-label">{{ 'CALENDAR.END_HOUR' | translate }}</span>
        @if (endToggle) {
          <span class="hour-picker">
            <app-mp-hour-picker [size]="'small'" [(inputValue)]="endTime">
            </app-mp-hour-picker>
          </span>
        }
      </div>
    </div>
  }

  <div class="calendar-actions">
    <app-mp-button class="calendar-action" [color]="'negative'"
    [size]="'medium'" [label]="'CALENDAR.REINITIALIZE'" (buttonClicked)="resetCalendar()"></app-mp-button>
    <app-mp-button class="calendar-action"
    [size]="'medium'" [label]="'GLOBAL.VALIDATE'" (buttonClicked)="confirmSelection()"></app-mp-button>
  </div>
</div>
